module.exports = __webpack_public_path__ + "img/dundrum_2.1ade8cb3.webp";